























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Icon } from '@alpha/ink'
import { Question, Response } from '@/store/modules/survey-store-module'
import { QuestionConfiguration } from '@/store/modules/survey-configuration-store-module'
import CollapsibleSection from '@/components/Survey/CollapsibleSection.vue'
import store from '@/store'
import { intersection } from 'lodash-es'
import { QuestionType } from '@shared/types/database'
import { getParentResponsesByQualifyingTags } from './Utilities/SurveyUtilities'

@Component({
  components: {
    Icon,
    CollapsibleSection
  }
})
export default class QuestionContext extends Vue {
  @Prop({ required: true }) question!: Question & { responses: Response[] }
  @Prop({ required: false }) parentQuestions: Question[] | undefined
  @Prop({ required: false }) questionConfig: QuestionConfiguration | undefined
  @Prop({ required: false }) filteredIndexResponses: Response[] | undefined
  @Prop({ required: false }) indexResponses: Response[] | undefined
  @Prop({ required: false }) publicView: Boolean | undefined

  showQuestionContext: boolean = false

  get questionLogicContext () {
    const qualifyingTags = this.question.qualifyingTags as string[]
    const questionTagLogic: {
      text: string,
      answers: string,
      count: number
    }[] = []
    let variantTagLogic:{ answer: string, count: number} | undefined

    if (this.parentQuestions?.length) {
      this.parentQuestions.sort((a, b) => a.order - b.order).forEach(q => {
        if (q.type === QuestionType.Variant && q.options?.length) {
          const options:string[] = q.options.reduce((optionsList:string[], o) => {
            const simTags = intersection(o.qualificationTags, qualifyingTags)
            return simTags.length ? optionsList.concat(o.configuration?.title || o.label || o.text) : optionsList
          }, [])
          variantTagLogic = { answer: options[0], count: this.indexResponses?.length || 0 }
        }
        if (q.type !== QuestionType.Variant && q.options?.length) {
          const parentQuestionRespondentCount = getParentResponsesByQualifyingTags(q, qualifyingTags, store.getters.survey.responsesByQuestion(q.id)).length
          const options:string[] = q.options.reduce((optionsList:string[], o) => {
            const simTags = intersection(o.qualificationTags, qualifyingTags)
            return simTags.length ? optionsList.concat(o.text) : optionsList
          }, [])

          questionTagLogic.push({
            text: q.configuration?.title || q.text,
            answers: options.join(', '),
            count: parentQuestionRespondentCount
          })
        }
      })
    }

    if (variantTagLogic) {
      const variantCount = variantTagLogic.count
      questionTagLogic.forEach(l => {
        l.count = variantCount
      })
    }

    return { questionTagLogic, variantTagLogic }
  }

  get questionTagLogic () {
    return this.questionLogicContext.questionTagLogic
  }

  get variantTagLogic () {
    return this.questionLogicContext.variantTagLogic
  }

  get hasContext () {
    if (this.publicView && !this.filteredResponsesText && this.questionTagLogic.length === 0 && !this.variantTagLogic) return false
    return this.filteredResponsesText || this.question.configuration?.title || this.questionLogicContext.questionTagLogic.length || this.questionLogicContext.variantTagLogic
  }

  get filteredResponsesText () {
    // Only for open ends that are not other
    if (QuestionType.TextArea !== this.question.type) return false
    if (this.filteredIndexResponses && this.indexResponses && this.filteredIndexResponses.length !== this.indexResponses.length) {
      return `Showing ${this.filteredIndexResponses.length} of ${this.indexResponses.length} open end responses.`
    }
  }

  async restoreQuestionText () {
    await store.dispatch.surveyConfiguration.deleteQuestionText({ questionId: this.question.id, type: 'title' })
  }

  manageResponses () {
    this.$router.push({
      name: 'respondents'
    })
  }
}
